import axios from "axios";
import { del, get, post, patch,  put } from "./branches_api_helper";
import * as url from "./branches_url_helper";





// Get features
export const getBranches = () => get(url.GET_BRANCHES);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewBranch = branch =>
  axios.post(url.ADD_NEW_BRANCH, branch, {
    headers: { "Content-Type": "application/json" }
  });



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateBranch = branch => patch(`${url.UPDATE_BRANCH}/${branch.id}`,  branch);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteBranch = branch => del(`${url.DELETE_BRANCH}/${branch.id}`);







export {
  //getLoggedInUser,
  
  
};
